export default "__VITE_ASSET__GW6SxNHR__"